import React, { useRef, useEffect } from 'react';
import { createCATview } from './CATview'
// import {sigmoid} from '../utils'

import './catview.css'
//import "./font-awesome-4.7.0/css/font-awesome.min.css"

export interface MyComponentProps {
  // Define your prop types here
  names: any[],
  edges: any[],
  edgeNames?: any[],
  width?: string,
  height?: string
  showWitNames?: boolean
  colorScale?: any[]
  parentHandleOnClick?: (wit: any, edge: any) => void
}

export const CATviewWrapper: React.FC<MyComponentProps> = ({ names, edges, edgeNames, parentHandleOnClick, width = "100%", height = "10em", showWitNames = true, colorScale }) => {
  const catViewRef = useRef<HTMLDivElement>(null); // Step 1: Create the ref
  let catViewInstance:any;

  function handleOnClick(wit: any, edge: any) {
    // const blockid = edgeNames && edgeNames[edge]
    catViewInstance.draw_scroll_spy(edge);
    parentHandleOnClick && parentHandleOnClick(wit, edge)


  }


  useEffect(() => {
    if (catViewRef.current && names.length > 0 && edges.length > 0) {
      catViewInstance = createCATview();

      catViewInstance.initialize();
      // NOTE: container Ref MUST be set after initialization
      catViewInstance.set_container_ref(catViewRef)

      if (!showWitNames) {
        catViewInstance.set_names(names.map(() => ("")));
      }
      else {
        catViewInstance.set_names(names);
      }
      if (colorScale) {
        catViewInstance.set_color_scale(colorScale[0], colorScale[1], colorScale[2]);
      }
      catViewInstance.set_edges(edges);
      catViewInstance.set_edge_names(edgeNames)
      catViewInstance.set_click_on_edge_callback(handleOnClick);

      catViewInstance.draw_svg(); // Assuming draw_svg accepts an element
    }
  }, [names, edges, width, height]); // Step 3: Use the ref in an effect


  return (
    <div ref={catViewRef} id="CATview" style={{ "width": width, "height": height }}>

    </div>
  )
}